export default __webpack_public_path__ + "static/media/validating-ticket.fa33e7de.png";